import SignatureTypes from './SignatureTypes';

export default {
  GOST_ALGORITHM_OID_2001: '1.2.643.2.2.19',
  GOST_ALGORITHM_OID: '1.2.643.7.1.1.1.1', //QES,
  GOST_ALGORITHM_OID_512: '1.2.643.7.1.1.1.2',
  GOST_ITEX_ALGORITHM: ['1.2.643.7.1.1.3.2', '1.2.643.7.1.1.3.3'], //VIPNET
};

export const VALIDATE_ERRORS = {
  CONTROL_SUM:
    'Вы не можете воспользоваться сертификатом, т.к. сертификат имеет некорректный формат',
  TO_DATE: 'Вы не можете воспользоваться сертификатом, т.к. срок действия сертификата истек',
  FROM_DATE:
    'Вы не можете воспользоваться сертификатом, т.к. срок действия сертификата еще не наступил',
  HAS_OGRN:
    'Вы не можете воспользоваться данным сертификатом, т.к. сертификат принадлежит юридическому лицу',
  INN:
    'Вы не можете воспользоваться данным сертификатом, т.к. в сертификате ЭП отсутствует ИНН, либо ИНН имеет ' +
    'некорректный формат',
  USER_INN:
    'Вы не можете воспользоваться сертификатом, т.к. контактные данные в сертификате отличаются от данных в ' +
    'профиле ЛК',
  CERTIFICATE_CHAIN:
    'Вы не можете воспользоваться сертификатом, т.к. УЦ, выдавший сертификат, не аккредитован ' +
    'Минцифры России, или не найдены сертификаты корневого УЦ. Проверьте корректность установки сертификата.',
  IS_GOST:
    'Вы не можете воспользоваться сертификатом, т.к.ключ сертификата не соответствует необходимому формату ' +
    '(ГОСТ Р 34.10-2012)',
  IS_REVOKED: {
    [SignatureTypes.QES]:
      'Вы не можете воспользоваться сертификатом, т.к. он отозван Удостоверяющим центром',
    [SignatureTypes.ITEX]: 'Вы не можете воспользоваться сертификатом, т.к. он отозван',
  },
  BAD_POLICIES:
    'Вы не можете воспользоваться сертификатом, т.к.сертификат не соответствует необходимому классу ' +
    'средства ЭП',
  UNKNOWN_CERTIFICATE: {
    [SignatureTypes.QES]:
      'У Вас не установлены КриптоПро ЭЦП Browser plug-in и/или КриптоПро CSP. Вы будете ' +
      'перенаправлены на страницу получения ЭП',
    [SignatureTypes.ITEX]:
      'У Вас не установлены необходимые средства ЭП (в частности ViPNet CSP), либо не установлен ' +
      'сам сертификат. Вы будете перенаправлены на страницу получения ЭП',
  },
};
